import { getStorageUser, getUserToken, saveStorageUser } from '../util/UserUtil';

export const HttpOperations = {
    login: "auth/token",
    code: "auth/code",
    logout: "auth/logout",

    entity: "entity",

    user: "user",
    game: "game",
    section: "category",
    question: "question",
    session: "session",
}

export const HttpMethod = {
    get: "GET",
    post: "POST",
    patch: "PATCH",
    delete: "DELETE",
    put: "PUT"
}

export const HttpConnection = async (operation, success, error, method = "GET", data = null, checkingAuth = false) => {
    let token = getUserToken();

    const request = await fetch(`${serverUrlEndpoint}${operation}`, {
        method: method,
        body: data === null ? null : JSON.stringify(data),
        headers: {
            'Authorization': `${token === null || checkingAuth ? '' : token}`,
            'Content-Type': 'application/json',
        }
    })

    let item = Object()

    if (!request.ok) {
        var auxUser = getStorageUser();
        if (((request.status === 401 && !checkingAuth) || (!checkingAuth && token === "")) && auxUser) {
            const params = {
                username: auxUser.usuario.username,
                password: auxUser.usuario.password,
            }

            HttpConnection(HttpOperations.login, (item) => {
                //Set password
                item.usuario.password = auxUser.usuario.password;
                //Update user token
                saveStorageUser(item);
                //Retry operation
                HttpConnection(operation, success, error, method, data, false);
            }, (errorCode) => error(errorCode), HttpMethod.post, params, true);
        } else {
            console.log(request.status)
            error(request.status);
        }
    } else {
        try {
            item = await request.json();
        } catch (error) {
            item = {};
        }
        success(item);
    }
}

const base64Encode = (buf) => {
    let string = '';
    (new Uint8Array(buf)).forEach(
        (byte) => { string += String.fromCharCode(byte) }
    )
    return btoa(string)
}

export const HttpImage = async (fileId, success, error, checkingAuth = false) => {
    let token = getUserToken();

    const request = await fetch(`${serverUrlEndpoint}file/${fileId}/file`, {
        method: HttpMethod.get,
        headers: { 'Authorization': `${token === null || checkingAuth ? '' : token}`, },
    })

    if (!request.ok) {
        if ((request.status === 401 && !checkingAuth) || (!checkingAuth && token === "")) {
            var auxUser = getStorageUser();

            const params = {
                username: auxUser.usuario.username,
                password: auxUser.usuario.password,
            }

            HttpConnection(HttpOperations.login, (item) => {
                //Set password
                item.usuario.password = auxUser.usuario.password;
                //Update user token
                saveStorageUser(item);
                //Retry operation
                HttpImage(fileId, success, error, false);
            }, (errorCode) => error(errorCode), HttpMethod.post, params, true);
        } else {
            error(request.status);
            console.log(request.status);
        }
    } else {
        let item = Object()
        try {
            let buffer = await request.arrayBuffer();
            item = `data:${"image/jpeg"};base64,${base64Encode(buffer)}`;
        } catch (error) {
            //item = {};
            console.log(error)
        }
        success(item);
    }
}

export const HttpFormData = async (operation, success, error, method = "POST", data, files = [], checkingAuth = false) => {
    let token = getUserToken();

    console.log(token)
    console.log(JSON.stringify(data))

    //Set formData values
    var formData = new FormData()
    if (files.length > 0)
        formData.append(files[0].key, files[0].value.file, `linqoz-${new Date().getTime()}.${files[0].extension ?? "png"}`);

    if (data)
        formData.append("data", JSON.stringify(data));

    const request = await fetch(`${serverUrlEndpoint}${operation}`, {
        method: method,
        body: formData,
        headers: { 'Authorization': `${token === null || checkingAuth ? '' : token}` },
    })

    let item = Object()

    if (!request.ok) {
        if ((request.status === 401 && !checkingAuth) || (!checkingAuth && token === "")) {
            var auxUser = getStorageUser();

            const params = {
                username: auxUser.usuario.username,
                password: auxUser.usuario.password,
            }

            HttpConnection(HttpOperations.login, (item) => {
                //Set password
                item.usuario.password = auxUser.usuario.password;
                //Update user token
                saveStorageUser(item);
                //Retry operation
                HttpFormData(operation, success, error, HttpMethod.post, data, files, false);
            }, (errorCode) => error(errorCode), HttpMethod.post, params, true);

        } else {
            error(request.status);
            console.log(request.status);
        }
    } else {
        try {
            item = await request.json();
        } catch (error) {
            item = {};
            console.log(error)
        }
        success(item);
    }
}


const debugMode = false;
//movil: 172.20.10.8
//wifi: 192.168.5.39

export const serverUrlEndpoint = debugMode ? "http://192.168.5.38:8084/linqoz/api/" : "https://api.linqoz.es/linqoz/api/";
export const imageURL = debugMode ? "http://192.168.5.38:8084/linqoz/api/" : "https://api.linqoz.es/linqoz/api/";